import React, { Component } from 'react';
import firebase from '../config/fbConfig';

const withFirebase = (WrappedComponent) => {
  class WithFirebase extends Component {
    constructor(props) {
      super(props);
    }
    render() {
      return (
        <WrappedComponent
          firebase={firebase}
          // messaging={firebase.messaging()}
          {...this.props}
        />
      );
    }
  }
  return WithFirebase;
};

export default withFirebase;
